import React, { useState } from 'react';
import { Button, Dialog, Heading, NavSide } from '../../../../components/base';
import { ChatPromptSetting } from './detail/ChatPromptSetting';
import { ToolSettingsContent } from '../../../../components/chat/ToolSettingsContent';
import { SkillPanel } from '../../../../components/skill/SkillPanel';
import { useAppDispatch, useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';
import { showSettingDialog } from '../../../../redux/features/app/appSlice';
import Image from '../../../../components/Image';

interface MenuItemType {
    id: string | number;
    label: string;
    href?: string;
    to?: string;
    icon?: string;
    subMenu?: MenuItemType[];
    content?: React.ReactNode;
}


export const ChatSettingDialog: React.FC = ({ }) => {
    const dispatch = useAppDispatch();
    const { settingDialogVisible, settingDialogType } = useAppSelector((state: RootState) => state.app);
    const [isOpen, setIsOpen] = useState(settingDialogVisible);
    
    const MenuItems: MenuItemType[] = [
        { id: 1, label: '개인 맞춤 설정', icon: 'setting', content: <ChatPromptSetting /> },
        // MCP 서버 설정은 도구 설정으로 통합됨
        // ...(window.electron?.isElectron ? [{id: 2, label: 'MCP 서버', icon: 'settings', content: <ConnectorSetting />}]:[]),
        { id: 3, label: '도구', icon: 'settings', content: <ToolSettingsContent /> },
        // 스킬 탭 (데스크탑 전용)
        ...(window.electron?.isElectron
            ? [{ id: 4, label: '스킬', icon: 'skill', content: <SkillPanel /> }]
            : []),
    ]


    // id로 메뉴 아이템 찾기
    const getMenuItemById = (id: number): MenuItemType => {
        return MenuItems.find(item => item.id === id) ?? MenuItems[0];
    }

    const [currentMenu, setCurrentMenu] = useState<MenuItemType>(getMenuItemById(settingDialogType));

    React.useEffect(() => {
        setIsOpen(settingDialogVisible);
        setCurrentMenu(getMenuItemById(settingDialogType));
    }, [settingDialogVisible, settingDialogType]);

    React.useEffect(() => {
        if (!isOpen) {
            setCurrentMenu(MenuItems[0]);
        }
    }, [isOpen])

    const onBoarding = process.env.REACT_APP_ONBOARDING === 'TRUE';
    const handleMenuSelect = (item: MenuItemType) => {
        const targetId = item.id;
        if (!item.subMenu) {
            const target = findAllMenuItems(MenuItems, item => item.id == targetId)
            // 부모 메뉴 찾기
            if (target) setCurrentMenu(target[0]);
        }

    }

    const findAllMenuItems = (menuItems: MenuItemType[], predicate: (item: MenuItemType) => boolean): MenuItemType[] => {
        const result: MenuItemType[] = [];

        function search(items: MenuItemType[]) {
            if (!items || items.length === 0) {
                return;
            }

            for (const item of items) {
                if (predicate(item)) {
                    result.push(item);
                }

                if (item.subMenu && item.subMenu.length > 0) {
                    search(item.subMenu);
                }
            }
        }

        search(menuItems);
        return result;
    }

    return (
        <div>
            {onBoarding ?
                <div className='onboarding-banner' onClick={() => {
                    setIsOpen(!isOpen);
                    dispatch(showSettingDialog({ visible: !isOpen, type: 1 }));
                }}>
                    <div className="contents-image"><Image url="images/new_banner.gif"></Image></div>
                    <Heading size="body2"><span className="description-emp">나만의 AI 맞춤 설정</span>을<br /> 완료해 주세요!</Heading>
                </div>
                : <div className='chat-setting'>
                    <Button
                        className='setting'
                        size="small"
                        iconOnly='setting'
                        variant="ghost"
                        onClick={() => {
                            setIsOpen(!isOpen);
                            dispatch(showSettingDialog({ visible: !isOpen, type: 1 }));
                        }}>
                        설정
                    </Button>
                </div>}
            <Dialog
                onClose={() => {
                    setIsOpen(false);
                    dispatch(showSettingDialog({ visible: false, type: 1 }));
                }}
                closeOnOutSide={true}
                size="large"
                isOpen={isOpen}
                title='설정'
                className='chat-setting-dialog'
            >
                <div className='setting-dialog'>
                    <div className='setting-menu'>
                        <NavSide menuName=''
                            menuItems={MenuItems}
                            initialActiveMenu={currentMenu.subMenu ? currentMenu.subMenu[0].id : currentMenu.id}
                            onClick={handleMenuSelect}
                        >
                        </NavSide>
                    </div>
                    {currentMenu.content && <div className='setting-content'>
                        {currentMenu.content}
                    </div>}
                </div>
            </Dialog>
        </div>
    );
};